export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "no_business_vertical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun produit d'assurance n'est ajouté à cette boutique."])},
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter"])},
        "sale_form_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulaire de vente"])},
        "Marketing page link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lien"])}
      },
      "en": {
        "no_business_vertical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No insurance product has been added to this store."])},
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])},
        "sale_form_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sale form"])},
        "Marketing page link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link"])}
      }
    }
  })
}
